// extracted by mini-css-extract-plugin
export default {"item":"SubMenuItem_item__f4wxQ","is-active":"SubMenuItem_is-active__IdHxQ"};